module.exports = __webpack_public_path__ + "img/protocol_banner.9a4dadce.jpg";